import React from 'react';
import v from 'vudu';
import copy from 'constants/copy';
import Text from 'components/Text';
import { styles as s, classes as c, colors, format as f, breakpoints } from 'stylesheet';
import SocialButton from 'components/SocialButton';
import Frame from 'components/svgs/Frame';
import Footer from 'components/Footer';
import get from 'utils/get';
import EmailForm from 'components/EmailForm';

import floaters from 'assets/floaters.png';
import floatersMini from 'assets/floaters-mini.png';
import adobeLogoImage from 'assets/bonusView/adobe-logo.svg';
import prLogoImage from 'assets/bonusView/pr-logo.png';
import prBeatImage from 'assets/bonusView/pr-beat-image.png';
import aeLogoImage from 'assets/bonusView/ae-logo.png';
import aeBeatImage from 'assets/bonusView/ae-beat-image.png';
import frameLogoImage from 'assets/bonusView/frame-logo.png';
import frameBeatImage from 'assets/bonusView/frame-beat-image.png';
import featureSpeedImage from 'assets/bonusView/feature-speed.svg';
import featureCollabImage from 'assets/bonusView/feature-collab.svg';
import featureShareImage from 'assets/bonusView/feature-share.svg';
import futureUi from 'assets/bonusView/future-ui.svg';

import mobileBeatAdobe from 'assets/bonusView/mobile-beat-adobe.svg';
import mobileBeatFrame from 'assets/bonusView/mobile-beat-frame.svg';
import mobileBeatZap from 'assets/bonusView/mobile-beat-zap.svg';

import facebookIcon from 'assets/bonusView/icon-facebook.svg';
import twitterIcon from 'assets/bonusView/icon-twitter.svg';
import dribbleIcon from 'assets/bonusView/icon-dribble.svg';

import SegmentWrapper from 'lib/segment';

const localClasses = v({
  bonusView: {
    paddingTop: '160px'
  },
  floaters: {
    backgroundImage: `url(${floatersMini})`,
    height: '240px',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    [breakpoints.lg]: {
      height: '440px',
      backgroundImage: `url(${floaters})`,
      backgroundPosition: '100% 0%',
    }
  },
  table: {
    borderRadius: '16px',
    display: 'flex',
    border: '1px solid rgba(28, 172, 244, 0.5)',
    marginTop: '60px'
  },
  tableCell: {
    margin: '20px 0',
    padding: '40px 40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  tableCellMiddle: {
    borderRight: '1px solid rgba(28, 172, 244, 0.3)',
    borderLeft: '1px solid rgba(28, 172, 244, 0.3)',
  },
  tableButton: {
    height: '46px',
    position: 'relative',
    width: '100%',
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: '1.5px',
    borderRadius: '7px',
    padding: '13px 0px 10px 0px',
    outline: 'none',
    borderColor: colors.spiroDiscoBall,
    color: colors.spiroDiscoBall,
    fontWeight: 600,
    marginTop: '60px',
    fontFamily: 'AvenirLTStd-Medium, sans-serif',
    '@composes': [
      s.buttonTransition,
    ],
    ':hover': {
      color: 'white',
      borderColor: colors.ebony,
      backgroundColor: colors.spiroDiscoBall,
      backgroundImage: `linear-gradient(-220deg, ${colors.spiroDiscoBall} -10%, ${colors.neonBlue} 100%)`,
      backgroundSize: '125%',
    }
  },
  tableStep: {
    display: 'flex',
    border: `2px solid ${colors.spiroDiscoBall}`,
    borderRadius: '50%',
    width: '44px',
    height: '44px',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 2.5rem auto',
    'p': { margin: '5px 0 0 0' }
  },
  inlineButton: {
    height: '46px',
    position: 'relative',
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderRadius: '7px',
    padding: '13px 32px 10px 32px',
    outline: 'none',
    borderColor: colors.spiroDiscoBall,
    color: colors.spiroDiscoBall,
    fontWeight: 600,
    '@composes': [
      s.buttonTransition,
    ],
    ':hover': {
      color: 'white',
      borderColor: colors.ebony,
      backgroundColor: colors.spiroDiscoBall,
      backgroundImage: `linear-gradient(-220deg, ${colors.spiroDiscoBall} -10%, ${colors.neonBlue} 100%)`,
      backgroundSize: '125%',
    }
  },
  ctaLink: {
    display: 'inline-block',
    paddingBottom: '5px',
    borderBottom: `2px solid ${colors.spiroDiscoBall}`
  },
  video: {
    mixBlendMode: 'lighten'
  },
  mobileBeat: {
    borderBottom: '1px solid rgba(18, 172, 243, 0.3)'
  },
  mobileBeatImage: {
    left: 0,
    position: 'absolute'
  },
  footer: {
    backgroundImage: 'linear-gradient(-45deg, #003045 0%, #060A35 100%)',
  },
  footerEnd: {
    '@composes': [s.flex],
    justifyContent: 'space-between'
  },
  footerSet: {
    display: 'flex',
    alignItems: 'center'
  },
  extraSection: {
    '@composes': [s.py5],
    paddingRight: '0px',
    paddingLeft: '0px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
    ':last-of-type': {
      borderBottom: 'none'
    }
  },
});

const renderMobile = links => (
  <div className={f(c.row, c.clearfix)}>
    <div className={f(localClasses.mobileBeat, c.col9, c.mxAuto, c.center, c.pb5)}>
      <img src={mobileBeatAdobe} alt={'Adobe'} className={localClasses.mobileBeatImage} />
      <div className={localClasses.tableStep}>
        <Text variant={'demiHeadline'} color={'spiroDiscoBall'}>1</Text>
      </div>
      <div className={f(c.mb3)}>
        <Text variant={'demiHeadline'}>{copy.bonusView.table.step1.heading}</Text>
      </div>
      <Text variant={'pBold'} color={'slate'}>{copy.bonusView.table.step1.subheading}</Text>
      <a href={links.ccTrial} target='_blank' onClick={() => SegmentWrapper.didClickCCTrial()}>
        <button className={localClasses.tableButton}>{copy.bonusView.table.step1.cta}</button>
      </a>
    </div>

    <div className={f(localClasses.mobileBeat, c.col9, c.mxAuto, c.center, c.pt5, c.pb5)}>
      <img src={mobileBeatFrame} alt={'Adobe'} className={localClasses.mobileBeatImage} />
      <div className={localClasses.tableStep}>
        <Text variant={'demiHeadline'} color={'spiroDiscoBall'}>2</Text>
      </div>
      <div className={f(c.mb3)}>
        <Text variant={'demiHeadline'}>{copy.bonusView.table.step2.heading}</Text>
      </div>
      <Text variant={'pBold'} color={'slate'}>{copy.bonusView.table.step2.subheading}</Text>
      <a href={links.frameTrial} target='_blank' onClick={() => SegmentWrapper.didClickStartFrameTrial()}>
        <button className={localClasses.tableButton}>{copy.bonusView.table.step2.cta}</button>
      </a>
    </div>

    <div className={f(c.col9, c.mxAuto, c.center, c.pt5, c.pb5)}>
      <img src={mobileBeatZap} alt={'Adobe'} className={localClasses.mobileBeatImage} />
      <div className={localClasses.tableStep}>
        <Text variant={'demiHeadline'} color={'spiroDiscoBall'}>3</Text>
      </div>
      <div className={f(c.mb3)}>
        <Text variant={'demiHeadline'}>{copy.bonusView.table.step3.heading}</Text>
      </div>
      <Text variant={'pBold'} color={'slate'}>{copy.bonusView.table.step3.subheading}</Text>
      <a href={links.framePlugin} target='_blank' onClick={() => SegmentWrapper.didClickFramePlugin()}>
        <button className={localClasses.tableButton}>{copy.bonusView.table.step3.cta}</button>
      </a>
    </div>
  </div>
);

const renderDesktop = links => (
  <div>
    <div className={f(c.row, c.clearfix, c.pb6)}>
      <div className={f(localClasses.table)}>
        <div className={f(localClasses.tableCell, c.col4, c.left, c.center)}>
          <div className={localClasses.tableStep}>
            <Text variant={'demiHeadline'} color={'spiroDiscoBall'}>1</Text>
          </div>
          <div className={f(c.mb3)}>
            <Text variant={'demiHeadline'}>{copy.bonusView.table.step1.heading}</Text>
          </div>
          <Text variant={'pBold'} color={'slate'}>{copy.bonusView.table.step1.subheading}</Text>
          <a href={links.ccTrial} target='_blank' onClick={() => SegmentWrapper.didClickCCTrial()}>
            <button className={localClasses.tableButton}>{copy.bonusView.table.step1.cta}</button>
          </a>
        </div>

        <div className={f(localClasses.tableCell, localClasses.tableCellMiddle, c.col4, c.left, c.center)}>
          <div className={localClasses.tableStep}>
            <Text variant={'demiHeadline'} color={'spiroDiscoBall'}>2</Text>
          </div>
          <div className={f(c.mb3)}>
            <Text variant={'demiHeadline'}>{copy.bonusView.table.step2.heading}</Text>
          </div>
          <Text variant={'pBold'} color={'slate'}>{copy.bonusView.table.step2.subheading}</Text>
          <a href={links.frameTrial} target='_blank' onClick={() => SegmentWrapper.didClickStartFrameTrial()}>
            <button className={localClasses.tableButton}>{copy.bonusView.table.step2.cta}</button>
          </a>
        </div>

        <div className={f(localClasses.tableCell, c.col4, c.left, c.center)}>
          <div className={localClasses.tableStep}>
            <Text variant={'demiHeadline'} color={'spiroDiscoBall'}>3</Text>
          </div>
          <div className={f(c.mb3)}>
            <Text variant={'demiHeadline'}>{copy.bonusView.table.step3.heading}</Text>
          </div>
          <Text variant={'pBold'} color={'slate'}>{copy.bonusView.table.step3.subheading}</Text>
          <a href={links.framePlugin} target='_blank' onClick={() => SegmentWrapper.didClickFramePlugin()}>
            <button className={localClasses.tableButton}>{copy.bonusView.table.step3.cta}</button>
          </a>
        </div>
      </div>
    </div>

    {/* CC Beat */}
    <div className={f(c.row, c.clearfix, c.pb6)}>
      <div className={f(c.col7, c.mxAuto, c.center)}>
        <img src={adobeLogoImage} alt={'Adobe Image'} />
        <Text variant={'headline'} color={'white'}>{copy.bonusView.ccCloudBeat.headline}</Text>
        <Text variant={'p'} color={'slate'} classes={c.pb4}>{copy.bonusView.ccCloudBeat.description}</Text>
        <a href={links.ccTrial} target='_blank' onClick={() => SegmentWrapper.didClickCCTrial()}>
          <button className={localClasses.inlineButton}>{copy.bonusView.ccCloudBeat.buttonText}</button>
        </a>
      </div>
    </div>

    {/* Premiere Pro Beat */}
    <div className={f(c.row, c.clearfix, c.pb5)}>
      <div className={f(c.col6, c.left)}>
        <img className={c.pb4} style={{ width: '100%' }} src={prBeatImage} alt={'Adobe Image'} />
      </div>
      <div className={f(c.col6, c.left, c.pl5)}>
        <img style={{ width: '50px' }} src={prLogoImage} alt={'Adobe Image'} />
        <Text variant={'headline'} color={'white'}>{copy.bonusView.prBeat.headline}</Text>
        <Text variant={'p'} color={'slate'} classes={c.pb3}>{copy.bonusView.prBeat.description}</Text>
        <a href={links.framePlugin} target='_blank' onClick={() => SegmentWrapper.didClickFramePlugin()}>
          <Text variant={'pBold'} color={'spiroDiscoBall'} classes={localClasses.ctaLink}>{copy.bonusView.prBeat.cta}</Text>
        </a>
      </div>
    </div>

    {/* After Effects Beat */}
    <div className={f(c.row, c.clearfix, c.pb5)}>
      <div className={f(c.col6, c.left, c.pl5)}>
        <img style={{ width: '50px' }} src={aeLogoImage} alt={'Adobe Image'} />
        <Text variant={'headline'} color={'white'}>{copy.bonusView.aeBeat.headline}</Text>
        <Text variant={'p'} color={'slate'} classes={c.pb3}>{copy.bonusView.aeBeat.description}</Text>
        <a href={links.framePlugin} target='_blank' onClick={() => SegmentWrapper.didClickFramePlugin()}>
          <Text variant={'pBold'} color={'spiroDiscoBall'} classes={localClasses.ctaLink}>{copy.bonusView.aeBeat.cta}</Text>
        </a>
      </div>
      <div className={f(c.col6, c.left)}>
        <img src={futureUi} />
      </div>
    </div>

    {/* Frame Beat */}
    <div className={f(c.row, c.clearfix, c.pb6)}>
      <div className={f(c.col8, c.mxAuto, c.pl5, c.center)}>
        <img style={{ width: '140px' }} src={frameLogoImage} alt={'Frame Image'} />
        <Text variant={'headline'} color={'white'} classes={f(c.pb3, c.pb2)}>{copy.bonusView.frameBeat.headline}</Text>
        <a href={links.frameTrial} target='_blank' onClick={() => SegmentWrapper.didClickStartFrameTrial()}>
          <button className={f(localClasses.inlineButton, c.mb4)}>{copy.bonusView.frameBeat.buttonText}</button>
        </a>
        <img style={{ width: '100%' }} src={frameBeatImage} alt={'Use Frame'} />
      </div>

      <div className={f(c.col7, c.mxAuto, c.pl5, c.center)}>
        <div className={f(c.row, c.clearfix, c.pb4)}>
          <div className={f(c.col4, c.center, c.left, c.pr2)}>
            <img src={featureSpeedImage} alt={'Speed'} />
            <Text variant={'p'} color={'white'}>{copy.bonusView.frameBeat.features.speed}</Text>
          </div>
          <div className={f(c.col4, c.center, c.left, c.px2)}>
            <img src={featureCollabImage} alt={'Collab'} />
            <Text variant={'p'} color={'white'}>{copy.bonusView.frameBeat.features.collab}</Text>
          </div>
          <div className={f(c.col4, c.center, c.left, c.pl2)}>
            <img src={featureShareImage} alt={'Share'} />
            <Text variant={'p'} color={'white'}>{copy.bonusView.frameBeat.features.share}</Text>
          </div>
        </div>

        <Text variant={'p'} color={'slate'}>{copy.bonusView.frameBeat.description}</Text>
      </div>
    </div>
  </div>
);

export default props => {
  const links = {
    ccTrial: `https://creative.adobe.com/redeem/code/${get(props, 'emailState.code')}`,
    framePlugin: 'https://frame.io/integrations?utm_source=dreamstation&utm_medium=web&utm_campaign=bonus',
    frameTrial: `https://app.frame.io/promotion?promo_code=DREAM768972&email=${get(props, 'emailState.email')}`
  };
  return (
    <section className={localClasses.bonusView}>
      <div className={f(c.row, c.clearfix)}>
        <div className={f(c.col12, c.lgCol6, c.left)}>
          <Text variant={'headline'} color={'white'}>{copy.bonusView.heading}</Text>
          <Text variant={'subheadlineLarge'}>{copy.bonusView.subheading}</Text>
        </div>
        <div className={f(localClasses.floaters, c.col12, c.lgCol6, c.left)}></div>
      </div>
      {props.isMobile ? renderMobile(links) : renderDesktop(links)}

      {/* Footer */}
      <div className={f(c.clearfix, localClasses.footer)}>
        <div className={f(c.row, c.clearfix, localClasses.extraSection)}>
          <div className={f(c.col11, c.mxAuto, localClasses.footerEnd)}>
            <div className={localClasses.footerSet}><Text variant={'p'}>{'Frame.io, Inc.'}</Text></div>
            <div className={localClasses.footerSet}><Frame /></div>
            <div className={localClasses.footerSet}>
              <a href="https://www.facebook.com/frameioapp" target='_blank'>
                <img src={facebookIcon} style={{ marginRight: '14px' }} />
              </a>
              <a href="https://twitter.com/Frame_io" target='_blank'>
                <img src={twitterIcon} style={{ marginRight: '14px' }} />
              </a>
              <a href="https://dribbble.com/frameio" target='_blank'>
                <img src={dribbleIcon} />
              </a>
            </div>
          </div>
        </div>
      </div>

    </section>
  )
}



// WEBPACK FOOTER //
// ./src/views/BonusView.js